import apiClient from '../axios';

export default {
    getNotificacionesPorUsuario(id_usuario) {
        return apiClient.get(`/notificaciones/usuario/${id_usuario}`);
    },
};
